// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { USER_SERVICE, UserServiceInterface } from '../../../../../services/user.services';
import { ErrorOverlayClass } from '../../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../popup-feedback/popup-feedback.directive';

@Component({
  selector: 'lbca-comment-forum-textarea',
  templateUrl: './comment-forum-textarea.component.html',
  styleUrl: './comment-forum-textarea.component.scss',
  imports: [IconComponent],
})
export class CommentForumTextareaComponent {
  private overlay = inject(Overlay);
  private elementRef = inject(ElementRef);

  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  private errorPopup: ErrorOverlayClass;

  @ViewChild('inputData', { static: true }) inputData!: ElementRef;
  contentHeigth: number = 0;

  public isTouched: boolean = false;
  public hasError: boolean = false;
  public isValid: boolean = false;
  public isFocused: boolean = false;

  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public errorCtrl: boolean = false;

  public enableCount: boolean = false;
  public maxChars: number = 300;
  public count: number = 0;
  public type: 'countup' | 'countdown' = 'countdown';

  public hasValue: boolean = false;

  public labelValue: string = '';
  public userValue: string = '';
  public helperTextValue: string = '';
  public placeholder = '';

  public userFullName = '';
  public userId;

  public maskIcon: string | null = null;
  public totalLines: number = 5;

  public value!: any;
  public valueToReturn!: any;

  public errorposition!: any;
  private readInputTimeOutDebounce: any = null;

  @Input() set countType(val: 'countup' | 'countdown') {
    this.type = val;
  }
  @Input() set limit(val: number) {
    this.maxChars = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set lines(value: number) {
    this.totalLines = value;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set textCount(value: boolean) {
    this.enableCount = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set user(value: string) {
    this.userValue = value;
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set inputValue(value: string) {
    if (value) {
      this.hasValue = true;
      this.valueToReturn = value;
      this.isTouched = true;
      this.inputData!.nativeElement.value = value;
      this.checkIsValidate();
      this.autoShrinkGrow();
      if (this.enableCount) this.charsControl(value);
    }
  }

  @Output() focusState = new EventEmitter();
  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor() {
    const overlay = this.overlay;
    const elementRef = this.elementRef;

    const { userId, fullname }: any = this.userService.getUserInfo()!;

    this.userFullName = fullname;
    this.userId = userId;

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  public setValue($event) {
    this.checkValue($event.target.value);
  }

  public autoShrinkGrow() {
    this.inputData!.nativeElement.style.overflow = 'hidden';
    this.inputData!.nativeElement.style.height = '0px';
    this.inputData!.nativeElement.style.height = this.inputData!.nativeElement.scrollHeight + 'px';
  }

  public inputKeyUpEvent($event) {
    this.autoShrinkGrow();
    clearTimeout(this.readInputTimeOutDebounce);
    this.hasError = false;
    this.readInputTimeOutDebounce = setTimeout(() => {
      this.valueToReturn = $event.target.value;
    }, 25);
  }

  public focusIn() {
    this.isTouched = true;
    this.isFocused = true;
    this.focusState.emit(true);
    this.errorPopup.setFocus(true);
  }

  public focusOut(): void {
    if (this.valueToReturn) this.validStatusEmmiter.emit(true);
    else this.validStatusEmmiter.emit(false);
    this.changeEmmiter.emit({
      userId: this.userId,
      userFullName: this.userFullName,
      content: this.valueToReturn,
    });
    setTimeout(async () => {
      this.isFocused = false;
      if (!this.inputData!.nativeElement.value) this.isTouched = false;
      this.checkIsValidate();
      this.errorPopup.setFocus(false);
    }, 25);
    this.focusState.emit(false);
  }

  private async checkIsValidate() {
    this.hasError = false;
    this.setErrorEmmiter.emit([]);
    this.validStatusEmmiter.emit(true);
  }

  private checkValue(value) {
    if (value) {
      this.isTouched = true;
      this.hasValue = true;
    } else {
      this.hasValue = false;
    }
  }

  public charsControl(input) {
    if (this.isDisabled) return;

    const size = input.length || 0;

    const totalchars = this.maxChars - size;
    let msg;

    if (this.type === 'countdown') {
      if (totalchars < 0) {
        this.errorCtrl = true;
        msg = `limite excedido em ${-totalchars} caracteres.`;
      } else {
        this.errorCtrl = false;
        msg = totalchars;
      }
    } else {
      if (size > this.maxChars) {
        this.errorCtrl = true;
        msg = `${this.maxChars - size} / ${this.maxChars}`;
      } else {
        this.errorCtrl = false;
        msg = `${size} / ${this.maxChars}`;
      }
    }

    return msg;
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.inputData!.nativeElement.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }
}
